import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaUser } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { logoutAction } from "../store/actions/authAction";
import cartImage from "../assets/img/white cart (1).png";
import cartDarkImage from "../assets/img/black cart (1).png";
import { useLocation } from "react-router-dom";

const InitialsDDL = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showClass, setShowClass] = useState(false);
  const { cartItems } = useSelector((state) => state.cart);
  const { darkMode } = useSelector((state) => state.global);
  const { uid } = useSelector((state) => state.authUser);
  const { singleUser } = useSelector((state) => state.user);
  const [itemCount, setItemCount] = useState();

  const handleCart = () => {
    history.push("/cart");
  };

  useEffect(() => {
    setItemCount(cartItems?.length);
  }, [cartItems, dispatch]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (showClass && !event.target.closest(".dropdown")) {
        setShowClass(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [showClass]);

  return (
    <div className="dropdown">
      {location?.pathname !== "/restaurants" && (
        <div
          style={{
            position: "relative",
            display: "inline-block",
            cursor: "pointer",
          }}
          onClick={handleCart}
        >
          {darkMode ? (
            <img
              src={cartImage}
              style={{ maxWidth: "55px", maxHeight: "55px" }}
              className="w-full mr-4"
              alt="cart logo"
            />
          ) : (
            <img
              src={cartDarkImage}
              style={{ maxWidth: "55px", maxHeight: "55px" }}
              className="w-full mr-4"
              alt="cart dark logo"
            />
          )}
          {itemCount > 0 && (
            <div
              style={{
                position: "absolute",
                top: "5px",
                right: "12px",
                backgroundColor: "red",
                borderRadius: "100%",
                fontSize: "12px",
                color: "white",
                minWidth: "20px",
                textAlign: "center",
              }}
            >
              {itemCount}
            </div>
          )}
        </div>
      )}

      <button className="dropbtn p-0" onClick={() => setShowClass(!showClass)}>
        {uid ? (
          singleUser?.imageURL ? (
            <img
              src={singleUser?.imageURL}
              alt="User Avatar"
              style={{
                borderRadius: "100%",
                objectFit: "cover",
                width: "55px",
                height: "55px",
              }}
            />
          ) : (
            <FaUser className="fs--44 p-2" />
          )
        ) : (
          <FaUser className="fs--44 p-2" />
        )}
      </button>
      <div className={`dropdown-content ${showClass ? "show" : ""}`}>
        {uid ? (
          <>
            <li onClick={() => history.push("/profile")}>Profile</li>
            <li onClick={() => history.push("/cart")}>Cart</li>
            <li onClick={() => dispatch(logoutAction())}>Logout</li>
          </>
        ) : (
          <>
            <li
              onClick={() => {
                window.location.replace("/main");
              }}
            >
              Login
            </li>
          </>
        )}
      </div>
    </div>
  );
};

export default InitialsDDL;
